import Vue from 'vue'
import $ from 'jquery'
import store from '@/store'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
   // Cliente
   {
      path: '/',
      name: 'Home',
      component: () => import('../views/Home.vue')
   },
   {
      path: '/categorias',
      name: 'Categorias',
      component: () => import('../views/Categorias.vue')
   },
   {
      path: '/historia',
      name: 'História',
      component: () => import('../views/Historia.vue')
   },
   {
      path: '/noticias',
      name: 'Noticias',
      component: () => import('../views/Noticias.vue')
   },
   {
      path: '/produtos/:filtros?',
      name: 'Produtos',
      component: () => import('../views/Produtos.vue')
   },
   {
      path: '/produto/:codigo/:nome?',
      name: 'Produto',
      component: () => import('../views/Produto.vue')
   },
   {
      path: '/downloads/:tab?',
      name: 'Downloads',
      component: () => import('../views/Downloads.vue')
   },
   {
      path: '/calculadora',
      name: 'Calculadora',
      component: () => import('../views/Calculadora.vue')
   },
   {
      path: '/encontreRevenda',
      name: 'Encontre_Revenda',
      component: () => import('../views/EncontreRevenda.vue')
   },
   {
      path: '/assistenciaTecnica',
      name: 'Assistência_Técnica',
      component: () => import('../views/AssistenciaTecnica.vue')
   },
   {
      path: '/noticia/:id',
      name: 'Noticia',
      component: () => import('../views/Noticia.vue')
   },
   {
      path: '/produtoDivulgacao/:codigo',
      name: 'Produto_Divulgação',
      component: () => import('../views/ProdutoDivulgacao.vue')
   },
]

const router = new VueRouter({
   mode: 'history',
   base: process.env.BASE_URL,
   routes
})

/* eslint-disable-next-line no-unused-vars */
router.beforeEach((to, from, next) => {
   $(".offcanvas__area").removeClass("opened");
   $(".body-overlay").removeClass("opened");
   $("#app > .wrapper").removeClass("toggled");

   store.dispatch('saveHistory', to)

   if (to.params.codigo && to.params.codigo != 'state') {
      document.title = 'Kawashima - Cód. '+ to.params.codigo;
   } else {
      document.title = 'Kawashima - '+ String(to.name).replace(/_/g, " ").replace(/-/g, "/").replace("Adm", "");
   }

   next()
})

export default router
